import Cookies from 'js-cookie'

export const TokenKey = 'web_login_token'

export function getToken() {
	const token = Cookies.get(TokenKey);
	if (token) {
		try {
			return JSON.parse(token);
		} catch (error) {
			return false;
		}
	}
	return false;
}

export function setToken(token) {

	return Cookies.set(TokenKey, JSON.stringify(token), {
		expires: 3
	})
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}